var React = require('react');
var ReactNative = require('react-native');

// var Overlay = require('./wrappers/react-native-overlay-wrapper.android.js');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var ReUpText = require('./ReUpText');
var Overlay = require('./Overlay');
var Keyboard = require('./wrappers/Keyboard-wrapper');
var Animated = require('./wrappers/Animated');
var ProgressOverlay = require('./ProgressOverlay');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKSpinner,
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var ProgressOverlay = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      title : "",
      color : "#000",
      isVisible : false,
      spinnerText : "",
      spinnerBody : "",
      initialOpacity : 0,
      appManager : {},
      layout : {x:0,y:0,width:100,height:100}
    }
  },

  getInitialState : function()
  {
    return {
      opacity: new Animated.Value(this.props.initialOpacity),
      isVisible: false,
    }
  },

  componentDidMount : function()
  {
  },

  _didFadeIn : false,
  setDidFadeIn : function(didFadeIn)
  {
    if( didFadeIn != this._didFadeIn )
    {
      if( didFadeIn ) this.fadeIn();
      else this.fadeOut();

      this._didFadeIn = didFadeIn;
    }
  },

  fadeIn : function()
  {
    var thisThing = this;
      thisThing.setState({isVisible:true});
    Animated.timing(
      this.state.opacity,
      {toValue: 1, duration:100},
    ).start(function()
    {

    });
  },

  fadeOut : function()
  {
    var thisThing = this;
    Animated.timing(
     this.state.opacity,
     {toValue: 0,
     duration:100},
    ).start(function()
    {
      thisThing.setState({isVisible:false});
    });
  },


  render: function()
  {
    this.setDidFadeIn(this.props.isVisible);
    //Keyboard.dismiss();
    if( !this.state.isVisible ) return null;

    var appManager = this.props.appManager;
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");

    if( this.props.spinnerText.length <= 0 )
    {
      return (
        <Animated.View style={[{position:'absolute', top:0, left:0, right:0, bottom:0},{opacity:this.state.opacity}]}>
          <BlurView blurType="dark" style={[styles.blurStyle,{width:this.props.layout.width}]}>
            <Overlay style={{flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
              <MKSpinner style={styles.progress} strokeColor={[buttonColor, buttonTitleColor]} />
              {this.props.children}
            </Overlay>
          </BlurView>
        </Animated.View>
      );
    }
    else
    {
      return (
        <Animated.View style={[{position:'absolute', top:0, left:0, right:0, bottom:0},{opacity:this.state.opacity}]}>
          <BlurView blurType="dark" style={{top:0, left:0, right:0, bottom:0}}>
            <Overlay style={{flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
              <View style={styles.progressMessageContainer}>
                <ReUpText appManager={appManager} isTitle={true} style={styles.progressMessage}>
                  {this.props.spinnerText}
                </ReUpText>
                <ReUpText appManager={appManager} isTitle={false} style={styles.progressMessage}>
                  {this.props.spinnerBody}
                </ReUpText>
                <MKSpinner style={styles.progress} strokeColor={[buttonColor, buttonTitleColor]}/>
                {this.props.children}
              </View>
            </Overlay>
          </BlurView>
        </Animated.View>
      );
    }


  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    justifyContent: 'center',
    flexDirection:'row',
    alignItems:'stretch'
  },
  blurStyle:{
    flex:1,
    justifyContent: 'center',
    alignItems:'stretch',
  },
  progressMessageContainer:{
    margin:20,
    backgroundColor:'white',
    borderRadius: 4,
    padding:8,
    borderWidth: 1,
    borderColor: '#DADADA',
  },
  progress: {
    alignSelf : 'center',
    backgroundColor : 'transparent',
  },
  progressMessage: {
    paddingBottom: 8,
    textAlign: 'center',
  }
});

module.exports = ProgressOverlay;
